"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFunction = void 0;
var _isDefined = require("../misc-checks/isDefined");
/**
 * Tests argument to see if it is a function
 *
 * @name isFunction
 * @param {argument} Argument to test
 * @returns {boolean} Result of function tests
 */
const isFunction = targetFunction => {
  return (0, _isDefined.isDefined)(targetFunction) && typeof targetFunction === "function";
};
exports.isFunction = isFunction;